import { PAGE_ELEMENT } from "./ComponentList";
import FormService from "../../services/form";
import ContactService from "../../services/contact";
import HtmlGenerator from "./HtmlGenerator";
import Utility from "../../utility/Utility";

export default class ComponentManager {
  static getCurrentComponentBorder(currentComponentIndex, index, isEditing) {
    return {
      border: "solid",
      borderWidth: 1,
      borderStyle: "dashed",
      borderColor:
        currentComponentIndex === index && isEditing ? "blue" : "transparent",
    };
  }

  static getComponentDefaultData(type) {
    switch (type) {
      case PAGE_ELEMENT.TEXT:
        return this.getTextDefaultData(type);
      case PAGE_ELEMENT.BUTTON:
        return this.getButtonDefaultData(type);
      case PAGE_ELEMENT.IMAGE:
        return this.getImageDefaultData(type);
      case PAGE_ELEMENT.VIDEO:
        return this.getVideoDefaultData(type);
      case PAGE_ELEMENT.SOCIAL_BUTTONS:
        return this.getSocialDefaultData(type);
      case PAGE_ELEMENT.COLLECTION:
        return this.getCollectionDefaultData(type);
      case PAGE_ELEMENT.FORM:
        return this.getFormDefaultData(type);
      case PAGE_ELEMENT.ICON:
        return this.getIconDefaultData(type);
      case PAGE_ELEMENT.IMAGE_TEXT:
        return this.getImageTextDefaultData(type);
      case PAGE_ELEMENT.CUSTOM_HTML:
        return this.getCustomHtmlDefaultData(type);
      default:
        return this.getTextDefaultData(type);
    }
  }
  static getTextDefaultData(type) {
    return {
      type: type,
      value: "Your custom text",
      style: {
        width: "fit-content",
        boxSizing: "border-box",
        fontSize: 16,
        color: "#000000",
        textAlign: "center",
        fontWeight: "normal",
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        paddingRight: 6,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "transparent",
        overflow: "hidden",
        alignSelf: "center",
        whiteSpace: "pre-wrap",
      },
    };
  }
  static getButtonDefaultData(type) {
    return {
      type: type,
      value: "Button Title",
      url: "",
      style: {
        width: "fit-content",
        boxSizing: "border-box",
        fontSize: 16,
        color: "#ffffff",
        textAlign: "center",
        fontWeight: "bold",
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 15,
        paddingRight: 15,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 4,
        backgroundColor: "#5a65d7",
        alignSelf: "center",
        overflow: "hidden",
        cursor: "pointer",
        outline: "none",
        border: "none",
        textDecoration: "none",
      },
    };
  }

  static getImageDefaultData(type) {
    return {
      type: type,
      value: "https://i.ibb.co/RD02XgX/Screenshot-2021-05-28-at-7-09-16-PM.png",
      style: {
        width: "100%",
        // height: "min-intrinsic",
        boxSizing: "border-box",
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "transparent",
        alignSelf: "center",
        overflow: "hidden",
        textAlign: "center",
      },
    };
  }

  static getVideoDefaultData(type) {
    return {
      type: type,
      value: {
        videoURL: "",
        videoThumbnail: "",
        autoplayEnabled: false,
      },
      style: {
        width: "100%",
        boxSizing: "border-box",
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "transparent",
        alignSelf: "center",
        overflow: "hidden",
        textAlign: "center",
      },
    };
  }

  static getSocialDefaultData(type) {
    return {
      type: type,
      value: [
        {
          isRequired: true,
          title: "Facebook",
          url: "",
          icon: "https://i.ibb.co/FX4mz7J/ic-facebook.png",
        },
        {
          isRequired: true,
          title: "Instagram",
          url: "",
          icon: "https://i.ibb.co/VNvh8BL/ic-instagram.png",
        },
        {
          isRequired: true,
          title: "Twitter",
          url: "",
          icon: "https://i.ibb.co/nfsKjqn/ic-twitter.png",
        },
        {
          isRequired: false,
          title: "LinkedIn",
          url: "",
          icon: "https://i.ibb.co/BzLpvD2/linkedin-2.png",
        },
        {
          isRequired: false,
          title: "Youtube",
          url: "",
          icon: "https://i.ibb.co/tJ6rf4x/youtube.png",
        },
        {
          isRequired: false,
          title: "WhatsApp",
          url: "",
          icon: "https://i.ibb.co/nn931VS/whatsapp-2.png",
        },
      ],
      style: {
        width: "fit-content",
        boxSizing: "border-box",
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 4,
        marginBottom: 4,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "transparent",
        alignSelf: "center",
        overflow: "hidden",
        iconSize: 26,
        cellSpacing: 10,
      },
    };
  }

  static getCollectionDefaultData(type) {
    return {
      type: type,
      value: [
        {
          title: "<b>Title</b>",
          description: "Description",
          icon: "https://i.ibb.co/h93Ztf7/image-8.png",
        },
        {
          title: "<b>Title</b>",
          description: "Description",
          icon: "https://i.ibb.co/h93Ztf7/image-8.png",
        },
        {
          title: "<b>Title</b>",
          description: "Description",
          icon: "https://i.ibb.co/h93Ztf7/image-8.png",
        },
      ],
      style: {
        width: "fit-content",
        boxSizing: "border-box",
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 4,
        marginBottom: 4,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "transparent",
        alignSelf: "center",
        overflow: "hidden",
        iconSize: 110,
        cellSpacing: 15,
        iconRadius: 0,
        titleColor: "#000000",
        titleSize: 14,
        descriptionColor: "#837c7c",
        descriptionSize: 14,
      },
    };
  }

  static getIconDefaultData(type) {
    return {
      type: type,
      value: [
        {
          title: "",
          description: "",
          icon:
            "https://s3.ap-southeast-1.amazonaws.com/cdn-crm-common-env/report/thumbnail/21806/1622616405313_deskera-logo-512.png",
        },
      ],
      style: {
        width: "fit-content",
        boxSizing: "border-box",
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 4,
        marginBottom: 4,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "transparent",
        alignSelf: "center",
        overflow: "hidden",
        iconSize: 60,
        cellSpacing: 6,
        iconRadius: 0,
        titleColor: "#000000",
        titleSize: 14,
        descriptionColor: "#837c7c",
        descriptionSize: 14,
      },
    };
  }

  static getImageTextDefaultData(type) {
    return {
      type: type,
      value: [
        {
          title: "<b>Header Text</b>",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.<br/><br/>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
          image:
            "https://i.ibb.co/RD02XgX/Screenshot-2021-05-28-at-7-09-16-PM.png",
        },
      ],
      style: {
        width: "100%",
        boxSizing: "border-box",
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 4,
        marginBottom: 4,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "transparent",
        alignSelf: "center",
        overflow: "hidden",
        imageSize: 50,
        cellSpacing: 2,
        imageRadius: 0,
        imageAlign: "left",
        textAlign: "left",
        titleColor: "#000000",
        titleSize: 18,
        descriptionColor: "#837c7c",
        descriptionSize: 14,
        containerSpacing: 48,
      },
    };
  }

  static getFormDefaultData(type) {
    let fieldsData = FormService.getContactData(true);
    let segmentsData = ContactService.getSegments();
    return {
      type: type,
      value: fieldsData,
      segmentId: segmentsData.length > 0 ? segmentsData[0].id : "",
      style: {
        width: "80%",
        boxSizing: "border-box",
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 4,
        marginBottom: 4,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "transparent",
        alignSelf: "center",
        overflow: "hidden",
        fieldSpacing: 10,
        labelSize: 12,
        labelColor: "#000000",
        fieldRadius: 4,
        fieldBorder: "#EBEBEB",
        fieldBackground: "#F8F7FA",
      },
      button: {
        value: "Submit",
        style: {
          buttonColor: "#ffffff",
          buttonSize: 18,
          buttonBackground: "#24bc4a",
        },
      },
      thankYouMsg: "Thank you for submitting form!",
      redirectURL: "",
    };
  }

  static getCustomHtmlDefaultData(type) {
    return {
      type: type,
      value: `<h1 style="font-size:24px;margin:0 0 20px 0;">Lorem ipsum dolor sit amet</h1><p style="margin:auto;font-size:16px;line-height:24px;width:70%;text-align: center">Lorem ipsum dolor sit amet, consectetur adipiscing elit. In tempus adipiscing felis, sit amet blandit ipsum <span style="color:red; font-weight: bold">volutpat sed</span>. Morbi porttitor, eget accumsan et dictum, nisi libero ultricies ipsum, posuere neque at erat.</p><p style="margin:0;font-size:16px;line-height:24px;"></p>`,
      style: {
        width: "100%",
        boxSizing: "border-box",
        paddingTop: 24,
        paddingBottom: 24,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 0,
        backgroundColor: "#f5f5f5",
        alignSelf: "center",
        overflow: "hidden",
        textAlign: "center",
      },
    };
  }
  /////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////

  static getEncodedDataToSave(pageData, pageType) {
    const htmlGenerator = new HtmlGenerator();
    let data = pageData;
    data.html = Utility.encodeHTML(
      htmlGenerator.getHTML(
        data.json.designElements,
        data.json.scripts,
        data.json.metaData,
        data.json.hash,
        pageType
      )
    );
    data.json = Utility.encodeJSON(data.json);
    return data;
  }
}
